module.exports = __webpack_public_path__ + "95c3ba7aa7f9bfff6b4a8335cf2ec233.fbx";